import { render, staticRenderFns } from "./dataDownLoad.vue?vue&type=template&id=f047cfaa&scoped=true"
import script from "./dataDownLoad.vue?vue&type=script&lang=js"
export * from "./dataDownLoad.vue?vue&type=script&lang=js"
import style0 from "./dataDownLoad.vue?vue&type=style&index=0&id=f047cfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f047cfaa",
  null
  
)

export default component.exports